export default __webpack_public_path__ + "static/media/29 - Time Intertainment - Logo.c31164e3.png";